export const SCRIPT_STATUS_CHIP = {
  idle: { label: 'Idle', color: 'default' },
  queued: { label: 'Queued', color: 'info' },
  generating: { label: 'Generating...', color: 'warning' },
  'rate limit': {
    label: 'Rate limited - retrying in 30 min',
    color: 'warning',
  },
  completed: { label: 'Completed', color: 'success' },
  failed: { label: 'Failed', color: 'error' },
};

export const SCRIPT_IN_PROGRESS_STATUSES = ['generating', 'queued', 'rate limit'];

export const ACTIVE_RENDER_STATUSES = [
  'queued',
  'setting_up',
  'rendering',
  'finalizing',
];

export const MEANINGFUL_RENDER_STATUSES = [
  'queued',
  'setting_up',
  'rendering',
  'finalizing',
  'completed',
  'failed',
];

export const VOICEOVER_STATUS_CHIP = {
  idle: { label: '—', color: 'default' },
  queued: { label: 'In queue', color: 'info' },
  generating: { label: 'Generating', color: 'warning' },
  completed: { label: 'Done', color: 'success' },
  failed: { label: 'Failed', color: 'error' },
};

export const PIPELINE_CHIP_SX = { height: 22, '& .MuiChip-label': { px: 1 } };

export const PIPELINE_RENDER_LABELS = {
  queued: 'In Queue',
  setting_up: 'Setting Up',
  rendering: 'Rendering',
  finalizing: 'Finalizing',
  completed: 'Completed',
  failed: 'Failed',
};

export const PIPELINE_RENDER_COLORS = {
  queued: 'default',
  setting_up: 'info',
  rendering: 'warning',
  finalizing: 'warning',
  completed: 'success',
  failed: 'error',
};

export const PIPELINE_STEP_STATUS = {
  pending: 'pending',
  in_progress: 'in_progress',
  completed: 'completed',
  failed: 'failed',
};

export const POLL_INTERVAL = 3000;
export const MAX_PREVIEW_LENGTH = 600;
export const pageSize = 10;

/** Default voice_id by profile number range (for Voice over config). */
export const VOICE_OVER_DEFAULT_BY_PROFILE = {
  /** Profile 1–20: voice_id for default config */
  low: { min: 1, max: 20, voice_id: 'G17SuINrv2H9FC6nvetn' },
  /** Profile 21–30: voice_id for default config */
  high: { min: 21, max: 30, voice_id: 'j9jfwdrw7BRfcR43Qohk' },
};
